import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  DirectStatus_Verified_getInstancew10gjsxm5l1j as DirectStatus_Verified_getInstance,
  OwnerStatus_Success_getInstancebzl48656m87y as OwnerStatus_Success_getInstance,
  PaymentSetupRequest2e2ymiizrwril as PaymentSetupRequest,
  VerificationRequest3eeavldn6rk90 as VerificationRequest,
  DirectStatus_DescriptorVerification_getInstance1kl5jqi32byal as DirectStatus_DescriptorVerification_getInstance,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  DirectStatus_AmountVerification_getInstanceorpj6tw48l74 as DirectStatus_AmountVerification_getInstance,
  DirectStatus_Failed_getInstance3unypatz9ynbl as DirectStatus_Failed_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import { get_notNullContractorsjk9enub7uol as get_notNullContractor } from '../../../selectedContractor.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { toInt2q8uldh7sc951 as toInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { delay1diib1rb84y4j as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
  bodyBold2czwdzwknab0k as bodyBold,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
} from '../../theming/Titles.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  Companion_getInstance33aui7uk8ap15 as Companion_getInstance_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  get_atEnd1cw5d2zgug26 as get_atEnd,
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atCenterEnd17oomnncsh8vk as get_atCenterEnd,
  get_atStart2tgdnaxgj04ln as get_atStart,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  textButton18d6zwa74vao7 as textButton,
} from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { dialog2nk0sz8wudj8p as dialog } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { LsErrorException1ikb4g50zc2ko as LsErrorException } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/LsErrorException.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { get_selectedApi2skzkr2pn0lot as get_selectedApi } from '../../../sdk/apiOptions.mjs';
import { hostIsSecure158mk00139d4n as hostIsSecure } from '../../../actuals/secureSiteCheck.js.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { SharedUtils_getInstanceggolgle4lzs6 as SharedUtils_getInstance } from '../../../../../../crowpay-shared/com/crowpay/sharedUtils.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../components/nav/crowpay.mjs';
import {
  GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog,
  confirmationDialog1lynowl7yd4cd as confirmationDialog,
} from '../../dialogs/GenericConfirmationDialog.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  LateInitSignal30crwrg540xyy as LateInitSignal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  WarningSemantic_getInstance2xxn62yaantj2 as WarningSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { IssueNode2x8c6ia7dmfdz as IssueNode } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/IssueNode.mjs';
import { validated3dw9xce8adqbh as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import {
  assertNotBlankk8x8axj5z9hq as assertNotBlank,
  assert1ckwbdkg35i20 as assert,
  assertNotNull1uaw2iegqzgw8 as assertNotNull,
  assertNotBlank1cpq7aqdam42n as assertNotBlank_0,
} from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { Companion_getInstance2v0f9t0g75gcs as Companion_getInstance_1 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_2 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { NumberInput16nzuc28fuw7p as NumberInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/NumberField.commonHtml.mjs';
import {
  issueText2dqtp9rg036jt as issueText,
  validates376qnagkfv6he as validates,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import { label287uhiq3m9m4z as label2 } from '../../components/label2.mjs';
import { subtext2z3zzf0nosi4q as subtext } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BankSetupStep_Start_instance;
var BankSetupStep_FinancialConnection_instance;
var BankSetupStep_DirectSetup_instance;
var BankSetupStep_DirectVerification_instance;
var BankSetupStep_Complete_instance;
var BankSetupStep_entriesInitialized;
function BankSetupStep_initEntries() {
  if (BankSetupStep_entriesInitialized)
    return Unit_instance;
  BankSetupStep_entriesInitialized = true;
  BankSetupStep_Start_instance = BankSetupStep().qjj('Start', 0);
  BankSetupStep_FinancialConnection_instance = BankSetupStep().qjj('FinancialConnection', 1);
  BankSetupStep_DirectSetup_instance = BankSetupStep().qjj('DirectSetup', 2);
  BankSetupStep_DirectVerification_instance = BankSetupStep().qjj('DirectVerification', 3);
  BankSetupStep_Complete_instance = BankSetupStep().qjj('Complete', 4);
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = $this.rjj_1.wi7($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.rjj_1.uiw_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var p = tmp_0;
  if (p == null) {
    var tmp_1 = $this.rjj_1.wiw_1.gah(BankSetupStep_Start_getInstance(), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  } else {
    var tmp0_safe_receiver = p.z9t_1;
    if (!equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v9u_1, OwnerStatus_Success_getInstance())) {
      var tmp_2 = $this.rjj_1.wiw_1.gah(BankSetupStep_FinancialConnection_getInstance(), $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
    } else {
      if (p.y9t_1 == null) {
        var tmp_3 = $this.rjj_1.wiw_1.gah(BankSetupStep_DirectSetup_getInstance(), $completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
      } else {
        var tmp1_safe_receiver = p.y9t_1;
        if (!equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c9v_1, DirectStatus_Verified_getInstance())) {
          var tmp_4 = $this.rjj_1.wiw_1.gah(BankSetupStep_DirectVerification_getInstance(), $completion);
          if (tmp_4 === get_COROUTINE_SUSPENDED())
            tmp_4 = yield tmp_4;
        } else {
          var tmp_5 = $this.rjj_1.wiw_1.gah(BankSetupStep_Complete_getInstance(), $completion);
          if (tmp_5 === get_COROUTINE_SUSPENDED())
            tmp_5 = yield tmp_5;
        }
      }
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.sjj_1.wiw_1.gah(BankSetupStep_FinancialConnection_getInstance(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.tjj_1.cj3($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ujj_1.uiw_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!(tmp == null)) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_session();
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1 = tmp_0.tfw().mff_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_notNullContractor();
    var tmp_2 = await_0(this_2, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var tmp$ret$2 = tmp_2;
    var tmp_3 = tmp_1.pfi(tmp$ret$2, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  var tmp_4 = $this.ujj_1.wiw_1.gah(BankSetupStep_Start_getInstance(), $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, confirmed, $completion) {
  if (confirmed) {
    var tmp = $this.vjj_1.qfs($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = $this.vjj_1.wi7($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1 = $this.vjj_1.wiw_1.gah(BankSetupStep_Start_getInstance(), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  return Unit_instance;
}
var DirectDepositInfo$directSetup$slambda$slambdaClass;
function DirectDepositInfo$directSetup$slambda$slambda() {
  if (DirectDepositInfo$directSetup$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.vjj_1 = this$0;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DirectDepositInfo$directSetup$slambda$slambdaClass = $;
  }
  return DirectDepositInfo$directSetup$slambda$slambdaClass;
}
function DirectDepositInfo$directSetup$slambda$slambda_0(this$0) {
  var i = new (DirectDepositInfo$directSetup$slambda$slambda())(this$0);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = $this.wjj_1.aj3($this.xjj_1, new (PaymentSetupRequest())($this.yjj_1.f2(), toInt($this.zjj_1.f2()), $this.ajk_1.f2(), $this.bjk_1.f2()), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
  var tmp_0 = delay(tmp$ret$0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = $this.wjj_1.wi7($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = $this.wjj_1.wiw_1.gah(BankSetupStep_DirectVerification_getInstance(), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  $this.yjj_1.mam('');
  $this.bjk_1.mam('');
  $this.zjj_1.mam('');
  $this.ajk_1.mam('');
  $this.cjk_1();
  return Unit_instance;
}
var DirectDepositInfo$directSetup$slambda$lambda$slambdaClass;
function DirectDepositInfo$directSetup$slambda$lambda$slambda() {
  if (DirectDepositInfo$directSetup$slambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($closer) {
        this.djk_1 = $closer;
      }
      sao($completion) {
        this.djk_1();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DirectDepositInfo$directSetup$slambda$lambda$slambdaClass = $;
  }
  return DirectDepositInfo$directSetup$slambda$lambda$slambdaClass;
}
function DirectDepositInfo$directSetup$slambda$lambda$slambda_0($closer) {
  var i = new (DirectDepositInfo$directSetup$slambda$lambda$slambda())($closer);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var DirectDepositInfo$directSetup$slambda$lambda$slambdaClass_0;
function DirectDepositInfo$directSetup$slambda$lambda$slambda_1() {
  if (DirectDepositInfo$directSetup$slambda$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $$this$button, $bankName, $routingNumber, $accountNumber, $accountName, $closer) {
        this.wjj_1 = this$0;
        this.xjj_1 = $$this$button;
        this.yjj_1 = $bankName;
        this.zjj_1 = $routingNumber;
        this.ajk_1 = $accountNumber;
        this.bjk_1 = $accountName;
        this.cjk_1 = $closer;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DirectDepositInfo$directSetup$slambda$lambda$slambdaClass_0 = $;
  }
  return DirectDepositInfo$directSetup$slambda$lambda$slambdaClass_0;
}
function DirectDepositInfo$directSetup$slambda$lambda$slambda_2(this$0, $$this$button, $bankName, $routingNumber, $accountNumber, $accountName, $closer) {
  var i = new (DirectDepositInfo$directSetup$slambda$lambda$slambda_1())(this$0, $$this$button, $bankName, $routingNumber, $accountNumber, $accountName, $closer);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ejk_1.uiw_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var p = tmp;
  var tmp_0;
  var tmp1_safe_receiver = p == null ? null : p.y9t_1;
  if (equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c9v_1, DirectStatus_AmountVerification_getInstance())) {
    var tmp_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_issues($this.fjk_1);
    var tmp_2 = await_0(this_1, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!tmp_2.i1()) {
      tmp_1 = true;
    } else {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_2 = get_issues($this.gjk_1);
      var tmp_3 = await_0(this_2, $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_1 = !tmp_3.i1();
    }
    if (tmp_1) {
      var tmp_4 = $this.hjk_1.gah(true, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      return Unit_instance;
    }
    var tmp_5 = $this.hjk_1.gah(false, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    var tmp_6 = Companion_instance;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = $this.fjk_1;
    var tmp_7 = await_1(this_3, $completion);
    if (tmp_7 === get_COROUTINE_SUSPENDED())
      tmp_7 = yield tmp_7;
    var tmp$ret$5 = tmp_7;
    var tmp_8 = tmp_6.s9s(ensureNotNull(tmp$ret$5));
    var tmp_9 = Companion_instance;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = $this.gjk_1;
    var tmp_10 = await_1(this_4, $completion);
    if (tmp_10 === get_COROUTINE_SUSPENDED())
      tmp_10 = yield tmp_10;
    var tmp$ret$6 = tmp_10;
    tmp_0 = new (VerificationRequest())(listOf([new (MonetaryValue())(tmp_8), new (MonetaryValue())(tmp_9.s9s(ensureNotNull(tmp$ret$6)))]));
  } else {
    var tmp3_safe_receiver = p == null ? null : p.y9t_1;
    if (equals(tmp3_safe_receiver == null ? null : tmp3_safe_receiver.c9v_1, DirectStatus_DescriptorVerification_getInstance())) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_5 = get_issues($this.ijk_1);
      var tmp_11 = await_0(this_5, $completion);
      if (tmp_11 === get_COROUTINE_SUSPENDED())
        tmp_11 = yield tmp_11;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!tmp_11.i1()) {
        var tmp_12 = $this.hjk_1.gah(true, $completion);
        if (tmp_12 === get_COROUTINE_SUSPENDED())
          tmp_12 = yield tmp_12;
        return Unit_instance;
      }
      var tmp_13 = $this.hjk_1.gah(false, $completion);
      if (tmp_13 === get_COROUTINE_SUSPENDED())
        tmp_13 = yield tmp_13;
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_6 = $this.ijk_1;
      var tmp_14 = await_1(this_6, $completion);
      if (tmp_14 === get_COROUTINE_SUSPENDED())
        tmp_14 = yield tmp_14;
      var tmp$ret$9 = tmp_14;
      tmp_0 = new (VerificationRequest())(VOID, tmp$ret$9);
    } else {
      return Unit_instance;
    }
  }
  var request = tmp_0;
  try {
    var tmp_15 = $this.ejk_1.bj3($this.jjk_1, request, $completion);
    if (tmp_15 === get_COROUTINE_SUSPENDED())
      tmp_15 = yield tmp_15;
    var tmp_16 = $this.ejk_1.wi7($completion);
    if (tmp_16 === get_COROUTINE_SUSPENDED())
      tmp_16 = yield tmp_16;
    var tmp_17 = $this.ejk_1.wiw_1.gah(BankSetupStep_Complete_getInstance(), $completion);
    if (tmp_17 === get_COROUTINE_SUSPENDED())
      tmp_17 = yield tmp_17;
  } catch ($p) {
    if ($p instanceof LsErrorException()) {
      var e = $p;
      dialog($this.jjk_1, VOID, ($this$dialog, closer) => {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())($this$dialog.pc());
        var tmp0_elvis_lhs = $this$dialog.cbb_1;
        var p = tmp0_elvis_lhs == null ? $this$dialog : tmp0_elvis_lhs;
        $this$dialog.ebb(p, view);
        view.xbm(true);
        title(view, e.udr_1.s4b_1);
        view.jbb(sizeConstraints(view, VOID, get_rem(30)), body(view, e.udr_1.r4b_1));
        var tmp = view.ibb(get_atEnd(view), get_primaryButton(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Button())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        body(view_0, 'OK');
        onClick(view_0, VOID, VOID, DirectDepositInfo$directVerification$slambda$lambda$slambda_0(closer));
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        $this$dialog.fbb(p, view);
        return Unit_instance;
      });
      var tmp_18 = $this.ejk_1.wi7($completion);
      if (tmp_18 === get_COROUTINE_SUSPENDED())
        tmp_18 = yield tmp_18;
      return Unit_instance;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
var DirectDepositInfo$directVerification$slambda$lambda$slambdaClass;
function DirectDepositInfo$directVerification$slambda$lambda$slambda() {
  if (DirectDepositInfo$directVerification$slambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($closer) {
        this.kjk_1 = $closer;
      }
      sao($completion) {
        this.kjk_1();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DirectDepositInfo$directVerification$slambda$lambda$slambdaClass = $;
  }
  return DirectDepositInfo$directVerification$slambda$lambda$slambdaClass;
}
function DirectDepositInfo$directVerification$slambda$lambda$slambda_0($closer) {
  var i = new (DirectDepositInfo$directVerification$slambda$lambda$slambda())($closer);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_6($this, confirmed, $completion) {
  if (confirmed) {
    var tmp = $this.ljk_1.qfs($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = $this.ljk_1.wi7($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1 = $this.ljk_1.wiw_1.gah(BankSetupStep_Start_getInstance(), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  return Unit_instance;
}
var DirectDepositInfo$directVerification$slambda$slambdaClass;
function DirectDepositInfo$directVerification$slambda$slambda() {
  if (DirectDepositInfo$directVerification$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.ljk_1 = this$0;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DirectDepositInfo$directVerification$slambda$slambdaClass = $;
  }
  return DirectDepositInfo$directVerification$slambda$slambdaClass;
}
function DirectDepositInfo$directVerification$slambda$slambda_0(this$0) {
  var i = new (DirectDepositInfo$directVerification$slambda$slambda())(this$0);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  var tmp = $this.mjk_1.pfs($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.mjk_1.wiw_1.gah(BankSetupStep_DirectSetup_getInstance(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  var tmp = $this.njk_1.qfs($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.njk_1.wi7($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = $this.njk_1.wiw_1.gah(BankSetupStep_Start_getInstance(), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
var DirectDepositInfo$complete$slambda$slambdaClass;
function DirectDepositInfo$complete$slambda$slambda() {
  if (DirectDepositInfo$complete$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.njk_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DirectDepositInfo$complete$slambda$slambdaClass = $;
  }
  return DirectDepositInfo$complete$slambda$slambdaClass;
}
function DirectDepositInfo$complete$slambda$slambda_0(this$0) {
  var i = new (DirectDepositInfo$complete$slambda$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_financeConnectionComplete__k04pul($this, $completion) {
  var tmp = $this.wi7($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.uiw_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (!(tmp_0 == null)) {
    var tmp_1 = $this.wiw_1.gah(BankSetupStep_DirectSetup_getInstance(), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  return Unit_instance;
}
var BankSetupStepClass;
function BankSetupStep() {
  if (BankSetupStepClass === VOID) {
    class $ extends Enum() {
      static qjj(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'BankSetupStep');
    BankSetupStepClass = $;
  }
  return BankSetupStepClass;
}
function DirectDepositInfo$renderInfo$lambda($this$remember) {
  return $this$remember.baj(get_selectedApi()).ffx() && hostIsSecure();
}
var DirectDepositInfo$renderInfo$slambdaClass;
function DirectDepositInfo$renderInfo$slambda() {
  if (DirectDepositInfo$renderInfo$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.rjj_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DirectDepositInfo$renderInfo$slambdaClass = $;
  }
  return DirectDepositInfo$renderInfo$slambdaClass;
}
function DirectDepositInfo$renderInfo$slambda_0(this$0) {
  var i = new (DirectDepositInfo$renderInfo$slambda())(this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function DirectDepositInfo$renderInfo$lambda$lambda($next, this$0) {
  return ($this$swap) => {
    var tmp;
    switch ($next.b4_1) {
      case 0:
        tmp = this$0.dj3($this$swap);
        break;
      case 1:
        tmp = this$0.ej3($this$swap);
        break;
      case 2:
        tmp = this$0.fj3($this$swap);
        break;
      case 3:
        tmp = this$0.gj3($this$swap);
        break;
      case 4:
        tmp = this$0.hj3($this$swap);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
}
var DirectDepositInfo$start$slambdaClass;
function DirectDepositInfo$start$slambda() {
  if (DirectDepositInfo$start$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.sjj_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DirectDepositInfo$start$slambdaClass = $;
  }
  return DirectDepositInfo$start$slambdaClass;
}
function DirectDepositInfo$start$slambda_0(this$0) {
  var i = new (DirectDepositInfo$start$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var DirectDepositInfo$financialConnection$slambdaClass;
function DirectDepositInfo$financialConnection$slambda() {
  if (DirectDepositInfo$financialConnection$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.tjj_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DirectDepositInfo$financialConnection$slambdaClass = $;
  }
  return DirectDepositInfo$financialConnection$slambdaClass;
}
function DirectDepositInfo$financialConnection$slambda_0(this$0) {
  var i = new (DirectDepositInfo$financialConnection$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var DirectDepositInfo$financialConnection$slambdaClass_0;
function DirectDepositInfo$financialConnection$slambda_1() {
  if (DirectDepositInfo$financialConnection$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.ujj_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DirectDepositInfo$financialConnection$slambdaClass_0 = $;
  }
  return DirectDepositInfo$financialConnection$slambdaClass_0;
}
function DirectDepositInfo$financialConnection$slambda_2(this$0) {
  var i = new (DirectDepositInfo$financialConnection$slambda_1())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function DirectDepositInfo$directSetup$lambda(it) {
  return SharedUtils_getInstance().p9s(it);
}
function DirectDepositInfo$directSetup$lambda_0($this$shownWhen) {
  return $this$shownWhen.baj(get_selectedApi()).afx_1;
}
var DirectDepositInfo$directSetup$lambda$slambdaClass;
function DirectDepositInfo$directSetup$lambda$slambda() {
  if (DirectDepositInfo$directSetup$lambda$slambdaClass === VOID) {
    class $ {
      constructor($bankName, $accountName, $routingNumber, $accountNumber) {
        this.ojk_1 = $bankName;
        this.pjk_1 = $accountName;
        this.qjk_1 = $routingNumber;
        this.rjk_1 = $accountNumber;
      }
      sao($completion) {
        this.ojk_1.mam('Test Bank');
        this.pjk_1.mam('Test Account');
        this.qjk_1.mam('110000000');
        this.rjk_1.mam('000123456789');
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DirectDepositInfo$directSetup$lambda$slambdaClass = $;
  }
  return DirectDepositInfo$directSetup$lambda$slambdaClass;
}
function DirectDepositInfo$directSetup$lambda$slambda_0($bankName, $accountName, $routingNumber, $accountNumber) {
  var i = new (DirectDepositInfo$directSetup$lambda$slambda())($bankName, $accountName, $routingNumber, $accountNumber);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var DirectDepositInfo$directSetup$slambdaClass;
function DirectDepositInfo$directSetup$slambda() {
  if (DirectDepositInfo$directSetup$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.sjk_1 = this$0;
      }
      sao($completion) {
        var tmp = get_dialogStack();
        tmp.dbw(new (GenericConfirmationDialog())('Switch Bank Account', 'This will require you to complete Step 1 again. Are you sure?', VOID, 'Start Over', VOID, VOID, true, true, VOID, VOID, DirectDepositInfo$directSetup$slambda$slambda_0(this.sjk_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DirectDepositInfo$directSetup$slambdaClass = $;
  }
  return DirectDepositInfo$directSetup$slambdaClass;
}
function DirectDepositInfo$directSetup$slambda_0(this$0) {
  var i = new (DirectDepositInfo$directSetup$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var DirectDepositInfo$directSetup$slambdaClass_0;
function DirectDepositInfo$directSetup$slambda_1() {
  if (DirectDepositInfo$directSetup$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$button, $bankName, this$0, $routingNumber, $accountNumber, $accountName) {
        this.tjk_1 = $$this$button;
        this.ujk_1 = $bankName;
        this.vjk_1 = this$0;
        this.wjk_1 = $routingNumber;
        this.xjk_1 = $accountNumber;
        this.yjk_1 = $accountName;
      }
      sao($completion) {
        dialog(this.tjk_1, VOID, ($this$dialog, closer) => {
          var agreed = Signal().fak(false);
          var tmp0_maxWidth = get_rem(40);
          var tmp1_minWidth = get_rem(10);
          var tmp = $this$dialog.ibb(sizeConstraints($this$dialog, tmp1_minWidth, tmp0_maxWidth), get_compact($this$dialog));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$dialog.pc());
          var tmp0_elvis_lhs = $this$dialog.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$dialog : tmp0_elvis_lhs;
          $this$dialog.ebb(p, view);
          view.xbm(true);
          bodyBold(view, 'Direct Deposit (ACH Credit) Authorization');
          body(view, 'I authorize Stoze to initiate electronic credit entries to my Bank account at the depository financial institution ' + this.ujk_1.f2() + '.');
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (Space())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          view.fbb(p_0, view_0);
          bodyBold(view, 'Error Correction Clause:');
          body(view, 'I further authorize Stoze to initiate debit entries to my account only to correct any erroneous credit entries previously made to my account. I understand that such debit entries will be limited to the amount of the error.');
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (Space())(view.pc());
          var tmp0_elvis_lhs_1 = view.cbb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
          view.ebb(p_1, view_1);
          view.fbb(p_1, view_1);
          bodyBold(view, 'Duration:');
          body(view, 'This authorization will remain in effect until Stoze has received written notification from me of its termination in such time and in such manner as to afford Stoze and my bank a reasonable opportunity to act on it.');
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (Space())(view.pc());
          var tmp0_elvis_lhs_2 = view.cbb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
          view.ebb(p_2, view_2);
          view.fbb(p_2, view_2);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_3 = view.cbb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
          view.ebb(p_3, view_3);
          view_3.xbm(false);
          var tmp_0 = get_centered(view_3);
          // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (Checkbox())(view_3.pc());
          var tmp0_elvis_lhs_4 = view_3.cbb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
          view_3.ebb(p_4, view_4);
          view_4.xah(view_4.cbk_1, agreed);
          view_3.fbb(p_4, view_4);
          view_3.jbb(tmp_0, view_4);
          view_3.jbb(get_centered(view_3), body(view_3, 'I acknowledge that the origination of ACH transactions to my account must comply with the provisions of U.S. law.'));
          view.fbb(p_3, view_3);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_5 = view.cbb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
          view.ebb(p_5, view_5);
          view_5.xbm(false);
          view_5.zb8(get_AppDimensions().ig2_1);
          var tmp_1 = get_expanding(view_5);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_6 = new (Space())(view_5.pc());
          var tmp0_elvis_lhs_6 = view_5.cbb_1;
          var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
          view_5.ebb(p_6, view_6);
          view_5.fbb(p_6, view_6);
          view_5.jbb(tmp_1, view_6);
          var tmp_2 = get_textButton(view_5);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_7 = new (Button())(view_5.pc());
          var tmp0_elvis_lhs_7 = view_5.cbb_1;
          var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
          view_5.ebb(p_7, view_7);
          specCenteredText(view_7, 'Decline');
          onClick(view_7, VOID, VOID, DirectDepositInfo$directSetup$slambda$lambda$slambda_0(closer));
          view_5.fbb(p_7, view_7);
          view_5.jbb(tmp_2, view_7);
          var tmp_3 = view_5.ibb(get_atEnd(view_5), get_primaryButton(view_5));
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_8 = new (Button())(view_5.pc());
          var tmp0_elvis_lhs_8 = view_5.cbb_1;
          var p_8 = tmp0_elvis_lhs_8 == null ? view_5 : tmp0_elvis_lhs_8;
          view_5.ebb(p_8, view_8);
          var tmp_4 = KMutableProperty0();
          var tmp_5 = Button$_get_enabled_$ref_61t7nx(view_8);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('enabled', 0, tmp_4, tmp_5, Button$_set_enabled_$ref_o8kynz(view_8));
          reactiveScope(view_8, ($this$reactiveScope) => {
            var tmp$ret$22 = $this$reactiveScope.baj(agreed);
            this_0.set(tmp$ret$22);
            return Unit_instance;
          });
          specCenteredText(view_8, 'Confirm');
          onClick(view_8, VOID, VOID, DirectDepositInfo$directSetup$slambda$lambda$slambda_2(this.vjk_1, view_8, this.ujk_1, this.wjk_1, this.xjk_1, this.yjk_1, closer));
          view_5.fbb(p_8, view_8);
          view_5.jbb(tmp_3, view_8);
          view.fbb(p_5, view_5);
          $this$dialog.fbb(p, view);
          $this$dialog.jbb(tmp, view);
          return Unit_instance;
        });
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DirectDepositInfo$directSetup$slambdaClass_0 = $;
  }
  return DirectDepositInfo$directSetup$slambdaClass_0;
}
function DirectDepositInfo$directSetup$slambda_2($$this$button, $bankName, this$0, $routingNumber, $accountNumber, $accountName) {
  var i = new (DirectDepositInfo$directSetup$slambda_1())($$this$button, $bankName, this$0, $routingNumber, $accountNumber, $accountName);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var DirectDepositInfo$directVerification$slambdaClass;
function DirectDepositInfo$directVerification$slambda() {
  if (DirectDepositInfo$directVerification$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $value1, $value2, $submitted, $code, $$this$button) {
        this.ejk_1 = this$0;
        this.fjk_1 = $value1;
        this.gjk_1 = $value2;
        this.hjk_1 = $submitted;
        this.ijk_1 = $code;
        this.jjk_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DirectDepositInfo$directVerification$slambdaClass = $;
  }
  return DirectDepositInfo$directVerification$slambdaClass;
}
function DirectDepositInfo$directVerification$slambda_0(this$0, $value1, $value2, $submitted, $code, $$this$button) {
  var i = new (DirectDepositInfo$directVerification$slambda())(this$0, $value1, $value2, $submitted, $code, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var DirectDepositInfo$directVerification$slambdaClass_0;
function DirectDepositInfo$directVerification$slambda_1() {
  if (DirectDepositInfo$directVerification$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.zjk_1 = this$0;
      }
      sao($completion) {
        var tmp = get_dialogStack();
        tmp.dbw(new (GenericConfirmationDialog())('Switch Bank Account', 'This will require to complete Steps 1 and 2 again. Are you sure?', VOID, 'Start Over', VOID, VOID, true, true, VOID, VOID, DirectDepositInfo$directVerification$slambda$slambda_0(this.zjk_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DirectDepositInfo$directVerification$slambdaClass_0 = $;
  }
  return DirectDepositInfo$directVerification$slambdaClass_0;
}
function DirectDepositInfo$directVerification$slambda_2(this$0) {
  var i = new (DirectDepositInfo$directVerification$slambda_1())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var DirectDepositInfo$directVerification$slambdaClass_1;
function DirectDepositInfo$directVerification$slambda_3() {
  if (DirectDepositInfo$directVerification$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.mjk_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DirectDepositInfo$directVerification$slambdaClass_1 = $;
  }
  return DirectDepositInfo$directVerification$slambdaClass_1;
}
function DirectDepositInfo$directVerification$slambda_4(this$0) {
  var i = new (DirectDepositInfo$directVerification$slambda_3())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var DirectDepositInfo$complete$slambdaClass;
function DirectDepositInfo$complete$slambda() {
  if (DirectDepositInfo$complete$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.ajl_1 = $$this$button;
        this.bjl_1 = this$0;
      }
      sao($completion) {
        var tmp = DangerButtonSemantic_getInstance();
        confirmationDialog(this.ajl_1, 'Remove Bank Information', 'You will not be able to withdraw any funds until your new Bank Information is added, approved, and microdeposits have been verified. Are you sure?', 'Remove Bank Information', VOID, tmp, true, true, VOID, VOID, DirectDepositInfo$complete$slambda$slambda_0(this.bjl_1));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DirectDepositInfo$complete$slambdaClass = $;
  }
  return DirectDepositInfo$complete$slambdaClass;
}
function DirectDepositInfo$complete$slambda_0($$this$button, this$0) {
  var i = new (DirectDepositInfo$complete$slambda())($$this$button, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function BankSetupStep_Start_getInstance() {
  BankSetupStep_initEntries();
  return BankSetupStep_Start_instance;
}
function BankSetupStep_FinancialConnection_getInstance() {
  BankSetupStep_initEntries();
  return BankSetupStep_FinancialConnection_instance;
}
function BankSetupStep_DirectSetup_getInstance() {
  BankSetupStep_initEntries();
  return BankSetupStep_DirectSetup_instance;
}
function BankSetupStep_DirectVerification_getInstance() {
  BankSetupStep_initEntries();
  return BankSetupStep_DirectVerification_instance;
}
function BankSetupStep_Complete_getInstance() {
  BankSetupStep_initEntries();
  return BankSetupStep_Complete_instance;
}
var DirectDepositInfoClass;
function DirectDepositInfo() {
  if (DirectDepositInfoClass === VOID) {
    class $ {
      constructor() {
        this.tiw_1 = new (Constant())(_Constant___init__impl__v45mub('Bank Info'));
        this.uiw_1 = LateInitSignal().raq();
        this.viw_1 = true;
        this.wiw_1 = LateInitSignal().raq();
      }
      ucv() {
        return this.tiw_1;
      }
      nje($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_financeConnectionComplete__k04pul.bind(VOID, this), $completion);
      }
      xiw(_this__u8e3s4) {
        var isSecure = remember(VOID, VOID, VOID, DirectDepositInfo$renderInfo$lambda);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        var tmp = shownWhen(view, VOID, ($this$shownWhen) => !$this$shownWhen.baj(isSecure));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(true);
        // Inline function 'com.lightningkite.kiteui.views.warning' call
        var tmp$ret$0 = view_0.hbb(WarningSemantic_getInstance());
        view_0.jbb(tmp$ret$0, title(view_0, 'You site connection is not secure. We cannot go through this setup with an unsecure connection'));
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        var tmp_0 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(isSecure));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_1 = view.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.ebb(p_1, view_1);
        view_1.xbm(true);
        launch(view_1, VOID, VOID, DirectDepositInfo$renderInfo$slambda_0(this));
        var previousStep = {_v: null};
        // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (SwapView())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        var this_0 = view_2;
        var queue = ArrayList().w();
        var alreadySwapping = {_v: false};
        reactiveScope(this_0, ($this$reactiveScope) => {
          var c = $this$reactiveScope.baj(this.wiw_1);
          queue.v(c);
          var tmp;
          if (alreadySwapping._v) {
            return Unit_instance;
          }
          alreadySwapping._v = true;
          $l$loop: while (true) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!!queue.i1()) {
              break $l$loop;
            }
            var next = queue.z3(0);
            try {
              var tmp0_safe_receiver = previousStep._v;
              var tmp_0;
              if (tmp0_safe_receiver == null) {
                tmp_0 = null;
              } else {
                // Inline function 'kotlin.let' call
                tmp_0 = tmp0_safe_receiver.d4(next) < 0 ? Companion_getInstance_0().rax_1 : Companion_getInstance_0().sax_1;
              }
              var tmp1_elvis_lhs = tmp_0;
              var transaction = tmp1_elvis_lhs == null ? Companion_getInstance_0().qax_1 : tmp1_elvis_lhs;
              previousStep._v = next;
              var tmp_1 = transaction;
              this_0.rci(tmp_1, DirectDepositInfo$renderInfo$lambda$lambda(next, this));
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                report(Exception().vd('Failed to render ' + toString(next), e), 'SwapView.swapping');
              } else {
                throw $p;
              }
            }
          }
          alreadySwapping._v = false;
          return Unit_instance;
        });
        view_1.fbb(p_2, view_2);
        view.fbb(p_1, view_1);
        view.jbb(tmp_0, view_1);
        _this__u8e3s4.fbb(p, view);
      }
      dj3(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        var tmp = view.ibb(get_atCenterEnd(view), get_tertiaryButton(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Button())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        specCenteredText(view_0, '+ Connect Account');
        onClick(view_0, VOID, VOID, DirectDepositInfo$start$slambda_0(this));
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
      ej3(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        title(view, 'Step 1 of 3: Verify Your Bank');
        body(view, 'Federal banking regulations require us to verify that your bank account is held in your business name. We use Stripe to make this connection securely \u2014 Stoze only receives your account name and last 4 digits. Your login credentials are never shared with us.');
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(false);
        var tmp = get_primaryButton(view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Button())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        specCenteredText(view_1, 'Connect with Stripe');
        onClick(view_1, VOID, VOID, DirectDepositInfo$financialConnection$slambda_0(this));
        view_0.fbb(p_1, view_1);
        view_0.jbb(tmp, view_1);
        var tmp_0 = get_textButton(view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Button())(view_0.pc());
        var tmp0_elvis_lhs_2 = view_0.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.ebb(p_2, view_2);
        specCenteredText(view_2, 'Cancel');
        onClick(view_2, VOID, VOID, DirectDepositInfo$financialConnection$slambda_2(this));
        view_0.fbb(p_2, view_2);
        view_0.jbb(tmp_0, view_2);
        view.fbb(p_0, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
      fj3(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        title(view, 'Step 2 of 3: Connect Your Account');
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (TextView())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.jba(view_0.ob6_1.ybe(BodySemantic_getInstance()));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(view_0);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(view_0));
        reactiveScope(view_0, ($this$reactiveScope) => {
          var tmp0_safe_receiver = $this$reactiveScope.baj(this.uiw_1);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z9t_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u9u_1;
          var tmp$ret$0 = 'Enter your routing and account numbers below so we know exactly where to send your payments. This must be the same account you setup in the previous step that ends with: ' + (tmp2_elvis_lhs == null ? 'N/A' : tmp2_elvis_lhs);
          this_0.set(tmp$ret$0);
          return Unit_instance;
        });
        view.fbb(p_0, view_0);
        var node = new (IssueNode())(null);
        var bankName = validated(Signal().fak(''), node);
        var accountName = validated(Signal().fak(''), node);
        var routingNumber = validated(Signal().fak(''), node);
        var accountNumber = validated(Signal().fak(''), node);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label = 'Bank Name';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_1 = view.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.ebb(p_1, view_1);
        view_1.xbm(true);
        view_1.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.xbm(false);
        view_2.zb8(get_AppDimensions().pg2_1);
        view_2.jbb(get_centered(view_2), bodyBold(view_2, label));
        view_2.jbb(colored(view_2, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_2, '*'));
        view_1.fbb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_1 = view_1.hbb(FieldSemantic_getInstance());
        var value = assertNotBlank(bankName);
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (TextInput())(view_1.pc());
        var tmp0_elvis_lhs_3 = view_1.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
        view_1.ebb(p_3, view_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value_0 = 'Bank Name';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_3.tb5_1.zb3_1.ib7_1.placeholder = value_0;
        view_3.abs(Companion_getInstance_1().qd5_1);
        view_3.xah(view_3.gcn_1, value);
        view_1.fbb(p_3, view_3);
        view_1.jbb(tmp_1, view_3);
        view.fbb(p_1, view_1);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label_0 = 'Account Name';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_4 = view.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
        view.ebb(p_4, view_4);
        view_4.xbm(true);
        view_4.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.ebb(p_5, view_5);
        view_5.xbm(false);
        view_5.zb8(get_AppDimensions().pg2_1);
        view_5.jbb(get_centered(view_5), bodyBold(view_5, label_0));
        view_5.jbb(colored(view_5, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_5, '*'));
        view_4.fbb(p_5, view_5);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_2 = view_4.hbb(FieldSemantic_getInstance());
        var value_1 = assertNotBlank(accountName);
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (TextInput())(view_4.pc());
        var tmp0_elvis_lhs_6 = view_4.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
        view_4.ebb(p_6, view_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value_2 = 'Account Name';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_6.tb5_1.zb3_1.ib7_1.placeholder = value_2;
        view_6.abs(Companion_getInstance_1().qd5_1);
        view_6.xah(view_6.gcn_1, value_1);
        view_4.fbb(p_6, view_6);
        view_4.jbb(tmp_2, view_6);
        view.fbb(p_4, view_4);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label_1 = 'Routing Number';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_7 = view.cbb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
        view.ebb(p_7, view_7);
        view_7.xbm(true);
        view_7.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())(view_7.pc());
        var tmp0_elvis_lhs_8 = view_7.cbb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
        view_7.ebb(p_8, view_8);
        view_8.xbm(false);
        view_8.zb8(get_AppDimensions().pg2_1);
        view_8.jbb(get_centered(view_8), bodyBold(view_8, label_1));
        view_8.jbb(colored(view_8, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_8, '*'));
        view_7.fbb(p_8, view_8);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_3 = view_7.hbb(FieldSemantic_getInstance());
        var value_3 = assert(routingNumber, 'Must be a valid routing number', VOID, VOID, DirectDepositInfo$directSetup$lambda);
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (TextInput())(view_7.pc());
        var tmp0_elvis_lhs_9 = view_7.cbb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_7 : tmp0_elvis_lhs_9;
        view_7.ebb(p_9, view_9);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value_4 = 'Routing Number';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_9.tb5_1.zb3_1.ib7_1.placeholder = value_4;
        view_9.abs(Companion_getInstance_1().sd5_1);
        view_9.xah(view_9.gcn_1, value_3);
        view_7.fbb(p_9, view_9);
        view_7.jbb(tmp_3, view_9);
        view.fbb(p_7, view_7);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label_2 = 'Account Number';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_10 = view.cbb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view : tmp0_elvis_lhs_10;
        view.ebb(p_10, view_10);
        view_10.xbm(true);
        view_10.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_11 = new (RowOrCol())(view_10.pc());
        var tmp0_elvis_lhs_11 = view_10.cbb_1;
        var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
        view_10.ebb(p_11, view_11);
        view_11.xbm(false);
        view_11.zb8(get_AppDimensions().pg2_1);
        view_11.jbb(get_centered(view_11), bodyBold(view_11, label_2));
        view_11.jbb(colored(view_11, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_11, '*'));
        view_10.fbb(p_11, view_11);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_4 = view_10.hbb(FieldSemantic_getInstance());
        var value_5 = assertNotBlank(accountNumber);
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_12 = new (TextInput())(view_10.pc());
        var tmp0_elvis_lhs_12 = view_10.cbb_1;
        var p_12 = tmp0_elvis_lhs_12 == null ? view_10 : tmp0_elvis_lhs_12;
        view_10.ebb(p_12, view_12);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value_6 = 'Account Number';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_12.tb5_1.zb3_1.ib7_1.placeholder = value_6;
        view_12.abs(Companion_getInstance_1().sd5_1);
        view_12.xah(view_12.gcn_1, value_5);
        view_10.fbb(p_12, view_12);
        view_10.jbb(tmp_4, view_12);
        view.fbb(p_10, view_10);
        var tmp_5 = get_atEnd(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_13 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_13 = view.cbb_1;
        var p_13 = tmp0_elvis_lhs_13 == null ? view : tmp0_elvis_lhs_13;
        view.ebb(p_13, view_13);
        view_13.xbm(false);
        shownWhen(view_13, VOID, DirectDepositInfo$directSetup$lambda_0);
        textButton(view_13, 'Use Test Account', ($this$textButton) => {
          onClick($this$textButton, VOID, VOID, DirectDepositInfo$directSetup$lambda$slambda_0(bankName, accountName, routingNumber, accountNumber));
          return Unit_instance;
        });
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
        Companion_getInstance_2();
        var tmp_6 = get_tertiaryButton(view_13);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_14 = new (Button())(view_13.pc());
        var tmp0_elvis_lhs_14 = view_13.cbb_1;
        var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
        view_13.ebb(p_14, view_14);
        specCenteredText(view_14, 'Switch Bank Account');
        onClick(view_14, VOID, VOID, DirectDepositInfo$directSetup$slambda_0(this));
        view_13.fbb(p_14, view_14);
        view_13.jbb(tmp_6, view_14);
        var tmp_7 = get_primaryButton(view_13);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_15 = new (Button())(view_13.pc());
        var tmp0_elvis_lhs_15 = view_13.cbb_1;
        var p_15 = tmp0_elvis_lhs_15 == null ? view_13 : tmp0_elvis_lhs_15;
        view_13.ebb(p_15, view_15);
        var tmp_8 = KMutableProperty0();
        var tmp_9 = Button$_get_enabled_$ref_61t7nx_0(view_15);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('enabled', 0, tmp_8, tmp_9, Button$_set_enabled_$ref_o8kynz_0(view_15));
        reactiveScope(view_15, ($this$reactiveScope) => {
          var tmp$ret$75 = $this$reactiveScope.baj(node.pat_1).i1();
          this_1.set(tmp$ret$75);
          return Unit_instance;
        });
        specCenteredText(view_15, 'Save Bank Account');
        onClick(view_15, VOID, VOID, DirectDepositInfo$directSetup$slambda_2(view_15, bankName, this, routingNumber, accountNumber, accountName));
        view_13.fbb(p_15, view_15);
        view_13.jbb(tmp_7, view_15);
        view.fbb(p_13, view_13);
        view.jbb(tmp_5, view_13);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
      gj3(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        title(view, 'Step 3 of 3: Confirm Your Account');
        var tmp = get_compact(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(false);
        var tmp_0 = get_centered(view_0);
        // Inline function 'com.crowpay.views.theming.bodyBold' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (TextView())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
        var tmp_1 = KMutableProperty0();
        var tmp_2 = TextView$_get_content_$ref_4pzcwl_0(view_1);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_0(view_1));
        reactiveScope(view_1, ($this$reactiveScope) => {
          var tmp0_safe_receiver = $this$reactiveScope.baj(this.uiw_1);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.z9u_1;
          var tmp$ret$0 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
          this_0.set(tmp$ret$0);
          return Unit_instance;
        });
        view_0.fbb(p_1, view_1);
        view_0.jbb(tmp_0, view_1);
        view_0.jbb(get_centered(view_0), body(view_0, '-'));
        var tmp_3 = get_centered(view_0);
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (TextView())(view_0.pc());
        var tmp0_elvis_lhs_2 = view_0.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.ebb(p_2, view_2);
        view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance()));
        var tmp_4 = KMutableProperty0();
        var tmp_5 = TextView$_get_content_$ref_4pzcwl_1(view_2);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_1(view_2));
        reactiveScope(view_2, ($this$reactiveScope) => {
          var tmp0_safe_receiver = $this$reactiveScope.baj(this.uiw_1);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.a9v_1;
          var tmp$ret$7 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
          this_1.set(tmp$ret$7);
          return Unit_instance;
        });
        view_0.fbb(p_2, view_2);
        view_0.jbb(tmp_3, view_2);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        view.jbb(shownWhen(view, VOID, ($this$shownWhen) => {
          var tmp0_safe_receiver = $this$shownWhen.baj(this.uiw_1);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
          return equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c9v_1, DirectStatus_Failed_getInstance());
        }), body(view, 'Account verification failed. You must redo step 2 and re-enter your bank account information.'));
        if (!this.viw_1) {
          var tmp_6 = shownWhen(view, VOID, ($this$shownWhen) => {
            var tmp0_safe_receiver = $this$shownWhen.baj(this.uiw_1);
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
            return !equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c9v_1, DirectStatus_Failed_getInstance());
          });
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (TextView())(view.pc());
          var tmp0_elvis_lhs_3 = view.cbb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
          view.ebb(p_3, view_3);
          view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance()));
          var tmp_7 = KMutableProperty0();
          var tmp_8 = TextView$_get_content_$ref_4pzcwl_2(view_3);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_2 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb_2(view_3));
          reactiveScope(view_3, ($this$reactiveScope) => {
            var tmp0_safe_receiver = $this$reactiveScope.baj(this.uiw_1);
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
            var type = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c9v_1;
            var tmp0 = type == null ? -1 : type.b4_1;
            var tmp$ret$18 = tmp0 === 2 ? 'Before we send real payments, we need to confirm your account is set up without errors. We\u2019ll send two small deposits between $0.01 and $0.99 to your account. When they arrives, go to the Bank Info page, enter the amounts, and you\u2019re done.' : tmp0 === 1 ? "Before we send real payments, we need to confirm your account is set up without errors. We\u2019ll send a small deposit to your account. When it arrives, check your bank transactions \u2014 it will include a verification code starting with 'SM'. Go to the Bank Info page, enter the code, and you\u2019re done." : '';
            this_2.set(tmp$ret$18);
            return Unit_instance;
          });
          view.fbb(p_3, view_3);
          view.jbb(tmp_6, view_3);
          view.jbb(shownWhen(view, VOID, ($this$shownWhen) => {
            var tmp0_safe_receiver = $this$shownWhen.baj(this.uiw_1);
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
            return !equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c9v_1, DirectStatus_Failed_getInstance());
          }), body(view, 'Your deposit is on its way. Check your bank transactions in the next 1-2 business days for a verification code, then go to the Bank Info page to enter it.'));
        } else {
          var tmp_9 = shownWhen(view, VOID, ($this$shownWhen) => {
            var tmp0_safe_receiver = $this$shownWhen.baj(this.uiw_1);
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
            return !equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c9v_1, DirectStatus_Failed_getInstance());
          });
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (TextView())(view.pc());
          var tmp0_elvis_lhs_4 = view.cbb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
          view.ebb(p_4, view_4);
          view_4.jba(view_4.ob6_1.ybe(BodySemantic_getInstance()));
          var tmp_10 = KMutableProperty0();
          var tmp_11 = TextView$_get_content_$ref_4pzcwl_3(view_4);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_3 = getPropertyCallableRef('content', 0, tmp_10, tmp_11, TextView$_set_content_$ref_pketfb_3(view_4));
          reactiveScope(view_4, ($this$reactiveScope) => {
            var tmp0_safe_receiver = $this$reactiveScope.baj(this.uiw_1);
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
            var type = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c9v_1;
            var tmp0 = type == null ? -1 : type.b4_1;
            var tmp$ret$25 = tmp0 === 2 ? 'Before we send real payments, we need to confirm your account is set up without errors. We\u2019ll send two small deposits between $0.01 and $0.99 to your account. When they arrives, come back to this section, enter the amounts, and you\u2019re done.' : tmp0 === 1 ? "Before we send real payments, we need to confirm your account is set up without errors. We\u2019ll send a small deposit to your account. When it arrives, check your bank transactions \u2014 it will include a verification code starting with 'SM'. Come back to this section, enter the code, and you\u2019re done." : '';
            this_3.set(tmp$ret$25);
            return Unit_instance;
          });
          view.fbb(p_4, view_4);
          view.jbb(tmp_9, view_4);
          view.jbb(shownWhen(view, VOID, ($this$shownWhen) => {
            var tmp0_safe_receiver = $this$shownWhen.baj(this.uiw_1);
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
            return !equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c9v_1, DirectStatus_Failed_getInstance());
          }), body(view, 'Your deposit is on its way. Check your bank transactions in the next 1-2 business days for a verification code, then return here to enter it.'));
          var value1 = assertNotNull(Signal().fak(null));
          var value2 = assertNotNull(Signal().fak(null));
          var code = assertNotBlank_0(Signal().fak(''));
          var submitted = Signal().fak(false);
          var tmp_12 = shownWhen(view, VOID, ($this$shownWhen) => {
            var tmp0_safe_receiver = $this$shownWhen.baj(this.uiw_1);
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
            return equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c9v_1, DirectStatus_AmountVerification_getInstance());
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_5 = view.cbb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
          view.ebb(p_5, view_5);
          view_5.xbm(false);
          label2(view_5, 'Amount 1', VOID, ($this$label2) => {
            // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
            var tmp$ret$32 = $this$label2.hbb(FieldSemantic_getInstance());
            var tmp = $this$label2.ibb(tmp$ret$32, sizeConstraints($this$label2, VOID, VOID, VOID, VOID, VOID, get_rem(5)));
            // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (NumberInput())($this$label2.pc());
            var tmp0_elvis_lhs = $this$label2.cbb_1;
            var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
            $this$label2.ebb(p, view);
            view.xah(view.xc5_1, value1);
            $this$label2.fbb(p, view);
            $this$label2.jbb(tmp, view);
            var tmp_0 = get_issues(value1);
            return issueText($this$label2, tmp_0, VOID, ($this$issueText) => $this$issueText.baj(submitted));
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_6 = new (Space())(view_5.pc());
          var tmp0_elvis_lhs_6 = view_5.cbb_1;
          var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
          view_5.ebb(p_6, view_6);
          view_5.fbb(p_6, view_6);
          label2(view_5, 'Amount 2', VOID, ($this$label2) => {
            // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
            var tmp$ret$39 = $this$label2.hbb(FieldSemantic_getInstance());
            var tmp = $this$label2.ibb(tmp$ret$39, sizeConstraints($this$label2, VOID, VOID, VOID, VOID, VOID, get_rem(5)));
            // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (NumberInput())($this$label2.pc());
            var tmp0_elvis_lhs = $this$label2.cbb_1;
            var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
            $this$label2.ebb(p, view);
            view.xah(view.xc5_1, value2);
            $this$label2.fbb(p, view);
            $this$label2.jbb(tmp, view);
            var tmp_0 = get_issues(value2);
            return issueText($this$label2, tmp_0, VOID, ($this$issueText) => $this$issueText.baj(submitted));
          });
          view.fbb(p_5, view_5);
          view.jbb(tmp_12, view_5);
          var tmp_13 = shownWhen(view, VOID, ($this$shownWhen) => {
            var tmp0_safe_receiver = $this$shownWhen.baj(this.uiw_1);
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
            return equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c9v_1, DirectStatus_DescriptorVerification_getInstance());
          });
          view.jbb(tmp_13, label2(view, 'Verification Code', VOID, ($this$label2) => {
            // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
            var tmp$ret$47 = $this$label2.hbb(FieldSemantic_getInstance());
            var tmp = $this$label2.ibb(tmp$ret$47, sizeConstraints($this$label2, VOID, VOID, VOID, VOID, VOID, get_rem(8)));
            // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (TextInput())($this$label2.pc());
            var tmp0_elvis_lhs = $this$label2.cbb_1;
            var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
            $this$label2.ebb(p, view);
            view.xah(view.gcn_1, code);
            // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
            // Inline function 'com.lightningkite.kiteui.views.placeholder' call
            view.tb5_1.zb3_1.ib7_1.placeholder = 'SM****';
            validates(view, [code], ($this$validates) => $this$validates.baj(submitted));
            $this$label2.fbb(p, view);
            $this$label2.jbb(tmp, view);
            subtext($this$label2, 'Enter the code that appears with your deposit in your bank transaction history.');
            var tmp_0 = get_issues(code);
            return issueText($this$label2, tmp_0, VOID, ($this$issueText) => $this$issueText.baj(submitted));
          }));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_7 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_7 = view.cbb_1;
          var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
          view.ebb(p_7, view_7);
          view_7.xbm(false);
          var tmp_14 = view_7.ibb(shownWhen(view_7, VOID, ($this$shownWhen) => {
            var tmp0_safe_receiver = $this$shownWhen.baj(this.uiw_1);
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
            return !equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c9v_1, DirectStatus_Failed_getInstance());
          }), get_primaryButton(view_7));
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_8 = new (Button())(view_7.pc());
          var tmp0_elvis_lhs_8 = view_7.cbb_1;
          var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
          view_7.ebb(p_8, view_8);
          specCenteredText(view_8, 'Verify & Complete');
          onClick(view_8, VOID, VOID, DirectDepositInfo$directVerification$slambda_0(this, value1, value2, submitted, code, view_8));
          view_7.fbb(p_8, view_8);
          view_7.jbb(tmp_14, view_8);
          var tmp_15 = view_7.ibb(shownWhen(view_7, VOID, ($this$shownWhen) => {
            var tmp0_safe_receiver = $this$shownWhen.baj(this.uiw_1);
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
            return !equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c9v_1, DirectStatus_Failed_getInstance());
          }), get_tertiaryButton(view_7));
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_9 = new (Button())(view_7.pc());
          var tmp0_elvis_lhs_9 = view_7.cbb_1;
          var p_9 = tmp0_elvis_lhs_9 == null ? view_7 : tmp0_elvis_lhs_9;
          view_7.ebb(p_9, view_9);
          specCenteredText(view_9, 'Switch Bank Account');
          onClick(view_9, VOID, VOID, DirectDepositInfo$directVerification$slambda_2(this));
          view_7.fbb(p_9, view_9);
          view_7.jbb(tmp_15, view_9);
          var tmp_16 = view_7.ibb(shownWhen(view_7, VOID, ($this$shownWhen) => {
            var tmp0_safe_receiver = $this$shownWhen.baj(this.uiw_1);
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
            return equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c9v_1, DirectStatus_Failed_getInstance());
          }), get_primaryButton(view_7));
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_10 = new (Button())(view_7.pc());
          var tmp0_elvis_lhs_10 = view_7.cbb_1;
          var p_10 = tmp0_elvis_lhs_10 == null ? view_7 : tmp0_elvis_lhs_10;
          view_7.ebb(p_10, view_10);
          specCenteredText(view_10, 'Start over');
          onClick(view_10, VOID, VOID, DirectDepositInfo$directVerification$slambda_4(this));
          view_7.fbb(p_10, view_10);
          view_7.jbb(tmp_16, view_10);
          view.fbb(p_7, view_7);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_11 = new (Space())(view.pc(), 0.5);
          var tmp0_elvis_lhs_11 = view.cbb_1;
          var p_11 = tmp0_elvis_lhs_11 == null ? view : tmp0_elvis_lhs_11;
          view.ebb(p_11, view_11);
          view.fbb(p_11, view_11);
        }
        _this__u8e3s4.fbb(p, view);
        return view;
      }
      hj3(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(false);
        var tmp = get_centered(view_0);
        // Inline function 'com.crowpay.views.theming.bodyBold' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (TextView())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
        var tmp_0 = KMutableProperty0();
        var tmp_1 = TextView$_get_content_$ref_4pzcwl_4(view_1);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_4(view_1));
        reactiveScope(view_1, ($this$reactiveScope) => {
          var tmp0_safe_receiver = $this$reactiveScope.baj(this.uiw_1);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.z9u_1;
          var tmp$ret$0 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
          this_0.set(tmp$ret$0);
          return Unit_instance;
        });
        view_0.fbb(p_1, view_1);
        view_0.jbb(tmp, view_1);
        view_0.jbb(get_centered(view_0), body(view_0, '-'));
        var tmp_2 = get_centered(view_0);
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (TextView())(view_0.pc());
        var tmp0_elvis_lhs_2 = view_0.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.ebb(p_2, view_2);
        view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance()));
        var tmp_3 = KMutableProperty0();
        var tmp_4 = TextView$_get_content_$ref_4pzcwl_5(view_2);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb_5(view_2));
        reactiveScope(view_2, ($this$reactiveScope) => {
          var tmp0_safe_receiver = $this$reactiveScope.baj(this.uiw_1);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.a9v_1;
          var tmp$ret$7 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
          this_1.set(tmp$ret$7);
          return Unit_instance;
        });
        view_0.fbb(p_2, view_2);
        view_0.jbb(tmp_2, view_2);
        view.fbb(p_0, view_0);
        var tmp_5 = view.ibb(get_atStart(view), get_tertiaryButton(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Button())(view.pc());
        var tmp0_elvis_lhs_3 = view.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
        view.ebb(p_3, view_3);
        specCenteredText(view_3, 'Switch Bank Account');
        onClick(view_3, VOID, VOID, DirectDepositInfo$complete$slambda_0(view_3, this));
        view.fbb(p_3, view_3);
        view.jbb(tmp_5, view_3);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    initMetadataForClass($, 'DirectDepositInfo', VOID, VOID, [Page()], [0, 2]);
    DirectDepositInfoClass = $;
  }
  return DirectDepositInfoClass;
}
//region block: exports
export {
  DirectDepositInfo as DirectDepositInfo1jikmxa3ta6ic,
};
//endregion

//# sourceMappingURL=DirectDepositInfo.mjs.map
